const workoutExplanationSectionTranslations = {
  generalTutorial: "General Tutorial",
  weightsAndRepsSheet: "Weights And Reps Sheet",
  progressiveOverload: "Progressive Overload",
  weight: "Weight",
  tempo: "Tempo",
  breathing: "Breathing",
  water: "Water",
  dailyExercise: "Daily Exercise",
  dropSet: "Drop Set",
  actionButton: "View",
};

export default workoutExplanationSectionTranslations;
